module.exports = __webpack_public_path__ + "img/Acmi_12.73ed808f.gif";